import React from "react";
import {Navigate, useLocation} from "react-router-dom";
import {LocalStorage} from "./LocalStorage";

export const AgencyPrivateRoute = ({children}) => {
    const location = useLocation();
    const userType = LocalStorage.fetchUserType();
    let can_pass = LocalStorage.hasUserData() && (userType === 'AGENCY_USER' || userType === 'CLIENT_USER');
    let redirectTo = '/login';
    if (can_pass) {
        const agencyStatus = LocalStorage.fetchAgencyStatus();
        const isSubscriptionPage = location.pathname === '/agency/subscription';

        if (agencyStatus === "Never Active" && !isSubscriptionPage) {
            can_pass = false;
            redirectTo = '/free-trial-ended'
        }

        if (agencyStatus === "Churned" && !isSubscriptionPage) {
            can_pass = false;
            redirectTo = '/subscription-ended'
        }

        // Agencias MCP solo pueden ver la pantalla de upsell en "/"
        if (can_pass && LocalStorage.fetchIsDashboMcp() && location.pathname !== '/') {
            return <Navigate to="/" />;
        }

        // CLIENT_USER: redirigir al portal (excepto desde "/" que maneja Default.js)
        if (can_pass && userType === 'CLIENT_USER' && location.pathname !== '/') {
            return <Navigate to="/portal" replace />;
        }
    }

    if (!can_pass && redirectTo === '/login') {
        // Guardar la URL completa (path + query string) para redirigir después del login
        const fullUrl = location.pathname + location.search;
        LocalStorage.saveRedirectUrl(fullUrl);
    }

    return can_pass ? children : <Navigate to={redirectTo}/>;
};

export const PortalPrivateRoute = ({children}) => {
    const userType = LocalStorage.fetchUserType();
    const hasData = LocalStorage.hasUserData();

    if (!hasData) {
        return <Navigate to="/login" />;
    }

    if (userType !== 'CLIENT_USER') {
        return <Navigate to="/" />;
    }

    const agencyStatus = LocalStorage.fetchAgencyStatus();
    if (agencyStatus === "Never Active") return <Navigate to="/free-trial-ended" />;
    if (agencyStatus === "Churned") return <Navigate to="/subscription-ended" />;

    return children;
};

export const CRMPrivateRoute = ({children}) => {
    const isCRMUser = LocalStorage.hasUserData() && LocalStorage.fetchUserType() === 'CRM_USER';
    return isCRMUser ? children : <Navigate to="/crm/login"/>;
};
